import React from "react";
import "../App.css"
// import { Search } from "lucide-react";

const PAGE_TITLES = {
  "user-list": "User List",
  "user-role-list": "User Role List",
  "user-role-mapping": "User Role Mapping List",
  "menu-list": "Menu List",
  "menu-role-mapping": "Menu Role Mapping List",
  dashboard: "Dashboard",
  schools: "Schools",
  teachers: "Teachers",
  students: "Students",
  exams: "Exams",
  books: "Books",
  fees: "Fees",
  centers: "Centers",
  notifications: "Notifications",
  reports: "Reports",
  "report-teacher-wise-book-assign": "Teacher Wise Book Assign Report",
  "report-students": "Students Report",
  "report-pending-payments": "Pending Payments Report",
  "report-payments": "Payments Report",
  settings: "Settings",
};

export default function Header({ page, overlay, setOverlay, sidebarOpen, onMenuToggle }) {
  const storedUser = JSON.parse(
    sessionStorage.getItem("user") || "{}"
  );

  const fullName =
    sessionStorage.getItem("fullName") ||
    `${storedUser?.firstName ?? storedUser?.FirstName ?? ""} ${
      storedUser?.lastName ?? storedUser?.LastName ?? ""
    }`.trim();

  const firstName =
    storedUser?.firstName ??
    storedUser?.FirstName ??
    "";

  const lastName =
    storedUser?.lastName ??
    storedUser?.LastName ??
    "";

  const avatar =
    storedUser?.avatar ??
    storedUser?.Avatar ??
    "";


  const initials =
    `${firstName?.charAt(0) || ""}${lastName?.charAt(0) || ""}`
      .toUpperCase() ||
    fullName
      .split(" ")
      .filter(Boolean)
      .slice(0, 2)
      .map((name) => name.charAt(0))
      .join("")
      .toUpperCase() ||
    "U";

  return (
  <div className="hdr">
    <div className="hdr-left">
      <button
        type="button"
        className={`mobile-menu-btn${sidebarOpen ? " open" : ""}`}
        onClick={onMenuToggle}
        aria-label={sidebarOpen ? "Close sidebar" : "Open sidebar"}
        aria-expanded={Boolean(sidebarOpen)}
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
      <div className="hdr-title">
        {PAGE_TITLES[page] || "ExamPro"}
      </div>
    </div>

    <div
      className="hdr-actions"
      style={{ marginLeft: "auto" }}
    >
      <div
        className="hdr-avatar"
        title={fullName}
        onClick={() =>
          setOverlay(
            overlay === "profile"
              ? ""
              : "profile"
          )
        }
      >
        {avatar ? (
          <img
            src={avatar}
            alt={fullName || "Profile"}
            style={{
              width: "100%",
              height: "100%",
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />
        ) : (
          initials
        )}
      </div>
    </div>
  </div>
);
}